import styled from '@emotion/styled'
import React, { HTMLAttributes } from 'react'

import { overrideOptional } from '@emico/overrides'
import { theme } from '@emico/styles'

const Wrapper = styled.div`
  @keyframes spinner {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }

  position: relative;
  width: 76px;
  height: 76px;
  margin: 0 auto;
  border: 4px solid ${theme.primaryColor};
  border-left-color: transparent;
  animation: spinner 0.65s linear infinite;
  border-radius: 50%;
`

type Props = HTMLAttributes<HTMLDivElement>

const Loader = (others: Props) => <Wrapper {...others} data-testid="loader" />

export default overrideOptional(Loader)
